import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text } from '@components/common';

const OptionContainer = styled(Box)`
  cursor: pointer;
  user-select: none;
`;

function PropertyOption(props) {
  const { isDisabled, innerProps, data, selectProps } = props;
  if (isDisabled) {
    return null;
  }

  const { propertyID, name, address, state, city, zipcode } = data;
  const fullAddress = `${address}, ${city}, ${state} ${zipcode}`;

  const { value } = selectProps;

  const { propertyID: selectedPropertyId } = value || {};

  const isSelected = propertyID === selectedPropertyId;

  return (
    <OptionContainer
      {...innerProps}
      px={3}
      py={2}
      bg={isSelected ? 'grey' : 'white'}
    >
      <Text color="darkerGray" mr={4}>
        {name}
      </Text>
      <Text color="darkGray" fontSize={0}>
        {fullAddress}
      </Text>
    </OptionContainer>
  );
}

PropertyOption.propTypes = {
  selectProps: PropTypes.object,
  innerProps: PropTypes.any,
  isDisabled: PropTypes.bool,
  data: PropTypes.object
};

export default PropertyOption;
